<template>
  <div style="text-align:left">
    <Breadcrumb style="margin: 0px 10px 20px">
        <BreadcrumbItem>投放管理</BreadcrumbItem>
    </Breadcrumb>
    <Card>
		<Form ref="form" :model="formItem" :label-width="100">
			<Row>
                <Col span="8">
                    <FormItem label="投放ID">
                        <Input v-model="formItem.plan_id"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="投放计划">
                        <Input v-model="formItem.plan_name"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="运行状态">
                        <Select v-model="formItem.status" multiple :max-tag-count="3">
                            <Option value="未开始">未开始</Option>
                            <Option value="进行中">进行中</Option>
                            <Option value="暂停中">暂停中</Option>
                            <Option value="提前结束">提前结束</Option>
                            <Option value="已结束">已结束</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="投放时间">
                        <DatePicker split-panels @on-change="handleChange"></DatePicker>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="投放广告">
                        <Select v-model="formItem.ad_id" filterable clearable :remote-method="adRemoteMethod" :loading="loading" @on-clear="handleClear">
                            <Option v-for="(item,index) in advertisements" :value="item.ad_id" :key="item.ad_id">{{item.title}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="广告版位">
                        <Select v-model="formItem.placement_id" filterable clearable :remote-method="placementRemoteMethod" :loading="loading1" @on-clear="handleClear1">
                            <Option v-for="(item,index) in placementList" :value="item.placement_id" :key="item.placement_id">{{item.medium_name + '-' + item.placement_name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="创建者">
                        <Select v-model="formItem.created_user_ids" multiple filterable clearable @on-query-change="createUserRemoteMethod" :loading="loading2" @on-clear="handleClear2">
                            <Option v-for="(item,index) in UserList" :value="item.user_id" :key="item.user_id">{{item.user_name }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <Button @click="getPlanList(1,20,formItem.plan_name,formItem.date,formItem.status,formItem.ad_id,formItem.placement_id,formItem.plan_id,formItem.created_user_ids)" style="margin-left:30px" type="primary">搜索</Button>
                    <Button @click="handleCreate" style="margin-left: 10px;" type="primary">新建投放计划</Button>
                </Col>
            </Row>
		</Form>
        <Table :columns="columns" :data="data" style="margin-top:10px"></Table>
        <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
        <Modal
            v-model="show_modal"
            title="修改状态"
            width='300px'
            @on-ok="okChange"
            @on-cancel="cancelChange">
            <Select v-model="status">
                <!-- <Option value="进行中" :disabled="selected_plan.status=='进行中'">运行</Option> -->
                <!-- <Option value="暂停中" :disabled="selected_plan.status=='暂停中'">暂停</Option> -->
                <Option value="提前结束">提前结束</Option>
            </Select>
        </Modal>
        <Modal
            v-model="show_modal1"
            title="修改标签"
            width='400px'
            @on-ok="okChangeLable"
            @on-cancel="cancelChangeLabel">
            <Form ref="form" :label-width="50">
			    <Row>
                    <FormItem label="规则">
                        <Select v-model="label_matching_rule_type">
                            <Option value="1">全部满足</Option>
                            <Option value="2">满足其一</Option>
                        </Select>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="标签">
                        <Select v-model="custom_rule_ids" style="width:300px" clearable :remote-method="remoteMethod" filterable multiple :max-tag-count="2">
                            <Option v-for="label in active_labels" :value="label.custom_rule_id+''" :key="label.custom_rule_id">{{label.name}}</Option>
                        </Select>
                    </FormItem>
                </Row>
            </Form>
        </Modal>
        <Modal
            v-model="show_modal2"
            draggable
            title="操作记录"
            width='800px'
            :footer-hide="true">
            <Timeline style="max-height: 500px;overflow: scroll;min-height: 100px;" >
                <TimelineItem v-for="(item,index) in operation_records" :key="index">
                    <p class="time">{{ item.created_at }}</p>
                    <p class="content">
                        <p>操作人：{{ item.user_name }}</p>
                        <p>操作类型：{{ item.operation_type }}</p>
                        <p>操作内容：{{ item.operation_content }}</p>
                    </p>
                </TimelineItem>
            </Timeline>
        </Modal>
	</Card>
  </div>
</template>
<script>
import{deletePlan, planList,updatePlanStatus,activeLabelList,updatePlanLabel,adList,placementList,showPlanOperationRecord,createUserList}from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'planAdmin',
    meta:{
        keepAlive: true // 开启缓存
    },
    data() {
        return {
            show_modal: false,
            show_modal1: false,
            show_modal2: false,
            custom_rule_ids: [],
            label_matching_rule_type: '2',
            active_labels: [],
            selected_plan: {},
            status: '',
            loading:false,
            advertisements: [],
            loading1:false,
            placementList: [],
            loading2:false,
            UserList: [],
            formItem:{
                plan_name: '',
                date: '',
                status: [],
                ad_id: '',
                placement_id: '',
                plan_id: '',
                created_user_ids: [],
            },
            columns: [
                {
                    title: "投放ID",
                    fixed: 'left',
                    key: "plan_id",
                    align: 'center',
                    width:100,
                },
                {
                    title: "投放计划名称",
                    key: "plan_name",
                    align: 'center',
                    width:100,
                },
                {
                    title: "投放版位",
                    key: "placement_names",
                    align: 'center',
                    width:100,
                },
                {
                    title: "投放时间",
                    key: "plan_period",
                    align: 'center',
                    width:100,
                },
                {
                    title: "投放状态",
                    key: "enable_flag",
                    align: 'center',
                    width:100,
                    render: (h, { row } ) => {
                        if (row.status === '提前结束' || row.status === '已结束') {
                            return h('span', {
                            }, '已结束');
                        } else if (row.enable_flag === 1) {
                            return h('span', {
                            }, '投放中');
                        } else if (row.enable_flag === 0) {
                            return h('span', {
                            }, '未投放');
                        } 
                    },
                },
                {
                    title: '运行状态',
                    key: 'status',
                    align: 'center',
                    width:100,
                },
                {
                    title: "投放方式",
                    key: "plan_type",
                    align: 'center',
                    width:120,
                    render: (h, { row } ) => {
                        if (row.plan_type === 1) {
                            return h('span', {
                            }, '按投放天数');
                        } else if (row.plan_type === 2) {
                            return h('span', {
                            }, '按曝光次数');
                        }else if (row.plan_type === 3) {
                            return h('span', {
                            }, '按点击次数');
                        }
                    },
                },
                {
                    title: "投放目标",
                    key: "target_number",
                    align: 'center',
                    width:100,
                    render: (h, { row } ) => {
                        if (row.plan_type === 1) {
                            return h('span', {
                            }, row.target_number+'天');
                        } else {
                            return h('span', {
                            }, row.target_number+'次');
                        }
                    },
                },
                {
                    title: "实际投放天数",
                    key: "actual_days",
                    align: 'center',
                    width:100,
                    render: (h, { row } ) => {
                        return h('span', {}, row.actual_days+'天');
                    },
                },
                {
                    title: "标签",
                    key: "labels",
                    align: 'center',
                    width:200,
                    render: (h, { row } ) => {
                        if (row.label_matching_rule_type == 1) {
                            return h('span', {}, row.labels.map((item,index)=>{return item.name}).join(" and "))
                        } else if (row.label_matching_rule_type == 2)  {
                            return h('span', {}, row.labels.map((item,index)=>{return item.name}).join(" or "))
                        }
                    },
                },
                {
                    title: "切换方式",
                    key: "ad_switch_type",
                    align: 'center',
                    width:50,
                    render: (h, { row }) => {
                        let color = '';
                        let text = '';
                        
                        switch(row.ad_switch_type) {
                            case 0:
                                color = '#808080';
                                text = '';
                                break;
                            case 1:
                                color = '#2d8cf0';
                                text = '轮换';
                                break;
                            case 2:
                                color = '#19be6b';
                                text = 'AB测';
                                break;
                            default:
                                color = '#808080';
                                text = '不切换';
                        }
                        
                        return h('span', {
                            style: {
                                color: color
                            }
                        }, text);
                    }
                },  
                {
                    title: "创建者",
                    key: "user_name",
                    align: 'center',
                    width:100,
                },
                {
                    title: "创建日期",
                    key: "created_at",
                    align: 'center',
                    width:100,
                },
                {
                    title: "更新日期",
                    key: "updated_at",
                    align: 'center',
                    width:100,
                },
                {
                    title: "操作",
                    fixed: 'right',
                    key: "action",
                    align: 'center',
                    width:180,
                    render: (h, params) => {
                        return h("div", [
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                                display:(params.row.status=='已结束' || params.row.status=='提前结束' || params.row.master_plan_flag != 1)?'none':'',
                            },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: "editPlan",
                                        query: {
                                            plan_id: params.row.plan_id,
                                        },
                                    });
                                },
                            },
                            },"编辑"),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                                display:((params.row.status=='已结束' || params.row.status=='提前结束') && params.row.master_plan_flag == 1)?'':'none',
                            },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: "planDetail",
                                        query: {
                                            plan_id: params.row.plan_id,
                                        },
                                    });
                                },
                            },
                            },"查看配置"),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                                display:((params.row.status=='已结束' || params.row.status=='提前结束')  && params.row.master_plan_flag == 1 )?'':'none',
                            },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: "relaunchPlan",
                                        query: {
                                            plan_id: params.row.plan_id,
                                        },
                                    });
                                },
                            },
                            },"再次投放"),
                        h("Button",{
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                                display:(params.row.status=='未开始' && params.row.master_plan_flag == 1)?'':'none',
                            },
                            on: {
                                click: () => {
                                this.$Modal.confirm({
                                    title: "提示",
                                    content: "是否删除该项？",
                                    onOk: () => {
                                        deletePlan({plan_id:params.row.plan_id}).then(res=>{
                                            if(res.data.code==200){
                                                this.$Message.success('删除成功');
                                                this.getPlanList(this.page,20,this.formItem.plan_name,this.formItem.date,this.formItem.status,this.formItem.ad_id,this.formItem.placement_id,this.formItem.plan_id,this.formItem.created_user_ids)
                                            }
                                        })
                                    },
                                });
                                },
                            },
                            },"删除"),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: "planStatistics",
                                        query: {
                                            plan_id: params.row.plan_id,
                                        },
                                    });
                                },
                            },
                            },"查看数据统计"),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                                display:(params.row.enable_flag==1 && (params.row.status=='进行中' || params.row.status=='暂停中')  && params.row.master_plan_flag == 1)?'':'none',
                            },
                            on: {
                                click: () => {
                                    this.show_modal = true
                                    this.selected_plan = params.row
                                    this.status = '提前结束'
                                },
                            },
                            },'提前结束'),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                                display:params.row.master_plan_flag == 1?'':'none',
                            },
                            on: {
                                click: () => {
                                    this.show_modal1 = true
                                    this.selected_plan = params.row
                                    this.custom_rule_ids = params.row.labels.map((item,index)=>{return item.custom_rule_id + ''})
                                    this.label_matching_rule_type = String(params.row.label_matching_rule_type)
                                },
                            },
                            },'修改标签'),
                            h("Button", {
                                props: {
                                    type: "text",
                                    size: "small",
                                },
                                style:{
                                    display:params.row.master_plan_flag == 1?'':'none',
                                },
                                on: {
                                    click: () => {
                                        this.operation_records = []
                                        this.handleGetOperationRecords(params.row.plan_id)
                                        this.show_modal2 = true
                                    },
                                },
                            },'操作记录')
                        ])
                    },
                },
            ],
            data:[],
            total_count:0,
            page:1,
            operation_records: []
        };
    },
    methods: {
        // 广告列表搜索
        getAdList(page=1,page_size=20,title=''){
            adList({page,page_size,title}).then(res=>{
                this.loading = false;
                if(res.data.code==200){
                    this.advertisements=res.data.data.advertisements
                }
            })
        },
        adRemoteMethod (query) {
            if (query !== '') {
                this.loading = true;
                this.getAdList(1, 20, query)
            } 
        },
        handleClear(){
            this.getAdList(1, 20)
        },
        // 广告版位列表搜索
        getPlacementList(page=1,page_size=20,placement_name='',medium_name=''){
            placementList({page,page_size,placement_name,medium_name}).then(res=>{
                this.loading1 = false;
                if(res.data.code==200){
                    this.placementList=res.data.data.placements
                }
            })
        },
        placementRemoteMethod (query) {
            if (query !== '') {
                this.loading = true;
                this.getPlacementList(1, 20, query)
            } 
        },
        handleClear1(){
            this.getPlacementList(1, 20)
        },
        // 投放计划创建人列表
        getCreateUserList(page=1,page_size=20,user_name=''){
            createUserList({page,page_size,user_name}).then(res=>{
                this.loading1 = false;
                if(res.data.code==200){
                    this.UserList=res.data.data.users
                }
            })
        },
        createUserRemoteMethod (query) {
            this.loading = true;
            this.getCreateUserList(1, 20, query)
        },
        handleClear2(){
            this.getCreateUserList(1, 20)
        },

        getActiveLabelList(keyword){
            activeLabelList({keyword}).then(res=>{
                if(res.data.code==200){
                    this.active_labels=res.data.data.rules
                }
            })
        },
        getPlanList(page,page_size,plan_name,date,status_list,ad_id,placement_id,plan_id,created_user_ids){
            let status = ''
            if (status_list){
                status = status_list.join(',')
            }
            if (created_user_ids){
                created_user_ids = created_user_ids.join(',')
            }
            planList({page,page_size,plan_name,date,status,ad_id,placement_id,plan_id,created_user_ids}).then(res=>{
                if(res.data.code==200){
                    this.data=res.data.data.plans
                    this.total_count=res.data.data.total
                    this.page = page
                }
            })
        },
        changePage(page){
            this.getPlanList(page,20,this.formItem.plan_name,this.formItem.date,this.formItem.status,this.formItem.ad_id,this.formItem.placement_id,this.formItem.plan_id,this.formItem.created_user_ids)
        },
        handleChange (date) {
            this.formItem.date = date
        },
        handleCreate(){
            this.$router.push({
                name: "createPlan",
            });
        },
        okChange(){
            updatePlanStatus({
                plan_id: this.selected_plan.plan_id,
                status: this.status
            }).then(res=>{
                if(res.data.code==200){
                    this.$Message.success('Success');
                    this.getPlanList(this.page,20,this.formItem.plan_name,this.formItem.date,this.formItem.status,this.formItem.ad_id,this.formItem.placement_id,this.formItem.plan_id,this.formItem.created_user_ids)
                }else{
                    this.$Message.success(res.data.msg);
                }
                this.selected_plan = {}
            })
            this.selected_plan = {}
            this.status = ''
        },
        cancelChange(){
            this.selected_plan = {}
            this.status = ''
        },
        okChangeLable(){
            updatePlanLabel({
                plan_id: this.selected_plan.plan_id,
                custom_rule_ids: this.custom_rule_ids.join(','),
                label_matching_rule_type:parseInt(this.label_matching_rule_type)
            }).then(res=>{
                if(res.data.code==200){
                    this.$Message.success('Success');
                    this.getPlanList(this.page,20,this.formItem.plan_name,this.formItem.date,this.formItem.status,this.formItem.ad_id,this.formItem.placement_id,this.formItem.plan_id,this.formItem.created_user_ids)
                }else{
                    this.$Message.success(res.data.msg);
                }
                this.selected_plan = {}
            })
            this.selected_plan = {}
            this.custom_rule_ids = []
        },
        cancelChangeLabel(){
            this.selected_plan = {}
            this.custom_rule_ids = []
        },
        remoteMethod (keyword) {
            if (keyword !== '' || keyword == null) {
                activeLabelList({keyword}).then(res => {
                    if (res.data.code==200){
                        const list = res.data.data.rules
                        this.active_labels = list.filter(item => item.name.indexOf(keyword) > -1);
                    }else{
                        this.$Message.error(res.data.msg)
                    }
                })
            } else {
                this.active_labels = []
            }
        },
        handleGetOperationRecords(plan_id){
            showPlanOperationRecord({plan_id}).then(res=>{
                if(res.data.code==200){
                    this.operation_records=res.data.data.operation_records    
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
        }
    },
    created() {
        this.getPlanList(1,20)
        Cookies.set('active_name', '3');
        this.getActiveLabelList('')
        this.getCreateUserList(1,20)
    },
    activated() {
        // 在这里刷新列表
        this.getPlanList(this.page,20,this.formItem.plan_name,this.formItem.date,this.formItem.status,this.formItem.ad_id,this.formItem.placement_id,this.formItem.plan_id,this.formItem.created_user_ids)
    },
};
</script>
<style scoped>
    .time{
        font-size: 14px;
        font-weight: bold;
    }
    .content{
        padding-left: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/views/Plan/PlanHome.vue